import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import common_en from '../../translations/en/translation.json';
import common_hi from '../../translations/hi/translation.json';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        common: common_en
      },
      hi: {
        common: common_hi
      }
    },
    detection: {
      order: ['htmlTag', 'cookie', 'navigator', 'path', 'subdomain'],
      caches: ['cookie']
    }
  }, () => {
    // Callback after initialization
    const initialLng = i18n.language || 'en'; // Use detected language or fallback to 'en'
    document.documentElement.lang = initialLng;
    if (initialLng === 'en') {
      document.documentElement.classList.add('notranslate');
    } else {
      document.documentElement.classList.remove('notranslate');
    }
  });

// Update lang attribute and toggle notranslate class on language change
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
  if (lng === 'en') {
    document.documentElement.classList.add('notranslate');
  } else {
    document.documentElement.classList.remove('notranslate');
  }
});

export default i18n;